import { IPermissions } from "../../../types/user/permissions/ipermissions/ipermissions.interface";
import { IFlyerDetailData } from "../types/flyer-detail-data/flyer-detail-data.interface";
import { calculatePermissions } from "../../../types/user/permissions/ipermissions/ipermissions.functions";
import { createFlyerPermissionsContext } from "../types/flyer-detail-data/flyer-detail-data.functions";
import { IUser } from "../../../types/user/iuser.interface";

export function createFlyerPermissions(user: IUser, flyer?: IFlyerDetailData): IPermissions {
  return calculatePermissions(createFlyerPermissionsContext(user, flyer));
}
